module.exports = __webpack_public_path__ + "img/vision2.ca4f8991.png";